import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Hero from '@/components/sections/Hero';
import Venues from '@/components/sections/Venues';
import SocialProof from '@/components/sections/SocialProof';
import Products from '@/components/sections/Products';
import Features from '@/components/sections/Features';
import EstablishmentsMap from '@/components/sections/EstablishmentsMap';
import Pricing from '@/components/sections/Pricing';
import FAQ from '@/components/sections/FAQ';
import CTA from '@/components/sections/CTA';

export default function Home() {
  const { hash } = useLocation();

  // Если пришли с /legal/* по ссылке вида /#pricing, прокручиваем к секции.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, '');
    const el = document.getElementById(id);
    if (el) {
      requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  }, [hash]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Venues />
        <Products />
        <Features />
        <EstablishmentsMap />
        <SocialProof />
        <Pricing />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
